import axios from 'axios';
import { API_BASE } from './config';
import { getTenantFromUrl } from './tenantUtils';

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    // Inject Tenant ID
    const tenant = getTenantFromUrl();
    if (tenant) {
      config.headers['X-Tenant-ID'] = tenant;
    }

    // Inject Auth Token & User Context
    try {
      const rawUser = localStorage.getItem('user');
      const rawSuperadmin = localStorage.getItem('superadmin_user');

      if (rawUser) {
        const user = JSON.parse(rawUser);
        if (user && user.token) {
          config.headers['Authorization'] = `Bearer ${user.token}`;
        }
        if (user && user.id) {
          config.headers['x-user-id'] = user.id;
        }
        if (user && (user.role || user.user_type)) {
          config.headers['x-user-role'] = user.role || user.user_type;
        }
      } else if (rawSuperadmin) {
        const superadmin = JSON.parse(rawSuperadmin);
        if (superadmin && superadmin.token) {
          config.headers['Authorization'] = `Bearer ${superadmin.token}`;
        }
        if (superadmin && superadmin.id) {
          config.headers['x-user-id'] = superadmin.id;
        }
        if (superadmin && (superadmin.role || superadmin.user_type)) {
          config.headers['x-user-role'] = superadmin.role || superadmin.user_type;
        }
      }
    } catch (e) {
      console.error('Error parsing user from localStorage', e);
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
